import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import Home from "./pages/Home/Home";
import Layout from "./UI/Layout";
import Service from "./pages/Service/Service";
import Login from "./pages/Login/Login";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Account from "./pages/Account/Account";
import ProductDetails from "./pages/Product/ProductDetails";
import Inquire from "./pages/inquire-page/Inquire";
import InquireSelect from "./pages/inquire-page/InquireSelect";
import Signup from "./pages/Signup/Signup";
import { AnimatePresence } from "framer-motion";
import InquireSuccess from "./pages/inquire-page/InquireSuccess";
import SubscribeSuccess from "./pages/Home/components/Subscribe/SubscribeSuccess";
import ForgetPassword from "./pages/Login/ForgetPassword";
import ProductPagination from "./pages/Product/ProductPagination";
import NotFound from "./UI/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import Product from "./pages/Product/Product";
import AccountLiked from "./pages/Account/AccountLiked";
import AccountQuestions from "./pages/Account/AccountQuestions";
import AccountInfo from "./pages/Account/AccountInfo";

const App = () => {
  const isAuth = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Layout>
      <AnimatePresence>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/service" element={<Service />} />
          <Route path="/product" element={<ProductPagination />} />
          {/* <Route path="/product/:page" element={<Product />} /> */}
          <Route path="/product/:productId" element={<ProductDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login/forgetPassword" element={<ForgetPassword />} />
          <Route path="/signup" element={<Signup />} />
          <Route element={<ProtectedRoute isAuth={isAuth} />}>
            <Route path="/account" element={<Account />}>
              <Route path="likedItems" element={<AccountLiked />} />
              <Route path="otherQuestions" element={<AccountQuestions />} />
              <Route path="personalInfo" element={<AccountInfo />} />
            </Route>
            <Route path="/inquire" element={<Inquire />} />
            <Route
              path="/inquire/fewMoreQuestions/inquire-successful"
              element={<InquireSuccess />}
            />
            <Route
              path="/inquire/fewMoreQuestions"
              element={<InquireSelect />}
            />
          </Route>

          <Route path="/subscribe-success" element={<SubscribeSuccess />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>
    </Layout>
  );
};

export default App;
